/** 与小程序 activity/signup.vue 一致的「活动信息收集」字段解析与表单项工具 */

export function parseActivityCollectFields(detail) {
  const d = detail && typeof detail === 'object' ? detail : {}
  let raw =
    d.signupActivityCollectJson ??
    d.signup_activity_collect_json ??
    d.activityInfoCollect ??
    null
  if (raw == null || raw === '') return []
  if (typeof raw === 'string') {
    try {
      raw = JSON.parse(raw)
    } catch {
      return []
    }
  }
  if (!Array.isArray(raw)) return []
  return raw
    .map((x, i) => {
      if (!x || typeof x !== 'object') return null
      const fieldKey = String(x.fieldKey || x.field_key || `field_${i}`).trim()
      if (!fieldKey) return null
      return {
        fieldKey,
        label: String(x.label || x.fieldLabel || fieldKey).trim(),
        fieldType: String(x.fieldType || x.field_type || 'TEXT').toUpperCase(),
        required: !!(x.required === true || x.required === 1 || x.requiredField === true || x.required_field === 1),
        optionsJson: String(x.optionsJson || x.options_json || '').trim(),
      }
    })
    .filter(Boolean)
}

export function normFieldType(f) {
  return String(f?.fieldType || '').toUpperCase()
}

export function isCheckGroup(f) {
  const t = normFieldType(f)
  return t === 'CHECKBOX' || t === 'CHECKBOX_GROUP'
}

export function fieldOptions(f) {
  const s = String(f?.optionsJson || '').trim()
  if (!s) return []
  try {
    const arr = JSON.parse(s)
    if (!Array.isArray(arr)) return []
    return arr
      .map((x) => {
        if (x && typeof x === 'object') {
          const label = String(x.label || x.value || '').trim()
          const value = String(x.value || x.label || '').trim()
          return { label, value }
        }
        const text = String(x || '').trim()
        return { label: text, value: text }
      })
      .filter((x) => x.label && x.value)
  } catch {
    return []
  }
}

export function newAttendee(collectFields) {
  const o = {
    name: '',
    phone: '',
    company: '',
    title: '',
    pickSource: 'other',
    managedMemberId: '',
  }
  ;(collectFields || []).forEach((f) => {
    const k = f.fieldKey
    if (!k) return
    o[k] = isCheckGroup(f) ? [] : ''
  })
  return o
}

export function normPhoneDigits(raw) {
  return String(raw || '').replace(/\D/g, '')
}

/** 将后台 raw-payload 转为可编辑的 attendees 列表 */
export function payloadToFormAttendees(payload, collectFields) {
  const p = payload && typeof payload === 'object' ? payload : {}
  let list = Array.isArray(p.attendees) ? p.attendees : []
  if (!list.length) {
    const one = newAttendee(collectFields)
    one.name = String(p.name || p.realName || '').trim()
    one.phone = String(p.phone || p.mobile || '').trim()
    one.company = String(p.company || p.companyName || '').trim()
    one.title = String(p.title || p.duty || '').trim()
    if (p.fromManagedMember) one.pickSource = 'managed'
    if (p.signupAsSelf) one.pickSource = 'self'
    list = [one]
  }
  return list.map((a, idx) => storedAttendeeToForm(a, collectFields, idx))
}

function storedAttendeeToForm(a, collectFields, idx) {
  const src = a && typeof a === 'object' ? a : {}
  const person = newAttendee(collectFields)
  person.name = String(src.name || '').trim()
  person.phone = String(src.phone || '').trim()
  person.company = String(src.company || '').trim()
  person.title = String(src.title || '').trim()
  if (src.fromManagedMember) person.pickSource = 'managed'
  else if (src.signupAsSelf) person.pickSource = 'self'
  person.managedMemberId = String(src.managedMemberId || src.managed_member_id || '').trim()
  person._stored = { ...src }
  ;(collectFields || []).forEach((f) => {
    const k = f.fieldKey
    if (!k) return
    const v = src[k]
    if (v === undefined || v === null) return
    person[k] = Array.isArray(v) ? [...v] : v
  })
  person._slotIndex = idx
  return person
}

/** 表单 attendees 写回 payload（保留原参会人上的审核/取消等系统字段） */
export function formAttendeesToPayload(formAttendees, collectFields, basePayload) {
  const next = basePayload && typeof basePayload === 'object' ? { ...basePayload } : {}
  next.attendees = (formAttendees || []).map((person) => {
    const stored = person._stored && typeof person._stored === 'object' ? { ...person._stored } : {}
    const o = stored
    o.name = String(person.name || '').trim()
    o.phone = String(person.phone || '').trim()
    o.company = String(person.company || '').trim()
    o.title = String(person.title || '').trim()
    delete o.fromManagedMember
    delete o.signupAsSelf
    if (person.pickSource === 'managed') o.fromManagedMember = true
    if (person.pickSource === 'self') o.signupAsSelf = true
    if (person.managedMemberId) o.managedMemberId = person.managedMemberId
    ;(collectFields || []).forEach((f) => {
      const k = f.fieldKey
      if (!k) return
      const v = person[k]
      if (typeof v === 'string') o[k] = v.trim()
      else o[k] = v
    })
    return o
  })
  return next
}

export function pillLabel(person, idx) {
  const n = String(person && person.name ? person.name : '').trim()
  return n || `报名者${idx + 1}`
}

export function validateAttendees(attendees, collectFields) {
  const errors = {}
  const list = attendees || []
  for (let i = 0; i < list.length; i += 1) {
    const p = list[i]
    if (!String(p.name || '').trim()) errors[`${i}-name`] = '请填写姓名'
    const phone = normPhoneDigits(p.phone)
    if (!/^1\d{10}$/.test(phone)) errors[`${i}-phone`] = '请填写11位手机号'
    if (!String(p.company || '').trim()) errors[`${i}-company`] = '请填写单位名称'
    if (!String(p.title || '').trim()) errors[`${i}-title`] = '请填写单位职务'
    ;(collectFields || []).forEach((f) => {
      if (!f.required) return
      const k = f.fieldKey
      if (!k) return
      const v = p[k]
      if (isCheckGroup(f)) {
        if (!Array.isArray(v) || !v.length) errors[`${i}-${k}`] = `请填写${f.label || k}`
      } else if (v === undefined || v === null || String(v).trim() === '') {
        errors[`${i}-${k}`] = `请填写${f.label || k}`
      }
    })
  }
  return errors
}

export function formatFirstValidateError(errs) {
  const keys = Object.keys(errs || {})
  if (!keys.length) return { message: '', slot: -1 }
  const firstKey = keys[0]
  const msg = errs[firstKey] || '请完善必填项'
  const slot = parseInt(String(firstKey).split('-')[0], 10)
  if (Number.isFinite(slot)) {
    return { message: `报名者${slot + 1}：${msg}`, slot }
  }
  return { message: msg, slot: -1 }
}

export function attendeeToSubmitRow(person, collectFields) {
  const p = person && typeof person === 'object' ? person : {}
  const o = {
    name: String(p.name || '').trim(),
    phone: String(p.phone || '').trim(),
    company: String(p.company || '').trim(),
    title: String(p.title || '').trim(),
  }
  ;(collectFields || []).forEach((f) => {
    const k = f.fieldKey
    if (!k) return
    const v = p[k]
    if (typeof v === 'string') o[k] = v.trim()
    else o[k] = v
  })
  return o
}
